module.exports = __webpack_public_path__ + "img/shop7-1.c9e495c5.png";